import React, { useEffect, useState } from 'react';
import { useTranslationService } from 'src/services/TranslationService';

const ErrorsRequest = (props) => {
    const { t } = useTranslationService();

    /*
    const [formattedErrors, setFormattedErrors] = useState();

    useEffect(() => {
        if (props.errors) generateErrors(props.errors);
    }, [props.errors]);
    */

    const generateErrors = (errors) => {
        const predefined = [{
            code: 'error-request',
            data: {},
        }];

        let errorsArray = [];
        let error = {};
        let data = {};
        let indexCode;

        if (typeof errors === 'object') {
            if (errors.length > 0) {
                for (let i = 0; i < errors.length; i++) {
                    error = {};
                    data = {};
                    indexCode = -1;
                    if (typeof errors[i]['code'] !== 'undefined' && errors[i]['code'] !== 'UNDEFINED') {
                        error.code = errors[i]['code'];
                        indexCode = errorsArray.findIndex(f => f.code == errors[i]['code']);
                        if (indexCode > -1 && typeof errors[i]['field'] !== 'undefined' && errors[i]['field'] && typeof errors[i]['value'] !== 'undefined') {
                            errorsArray[indexCode].data[errors[i]['field']] = errors[i]['value'] || '---';
                        } else if (typeof errors[i]['field'] !== 'undefined' && errors[i]['field'] && typeof errors[i]['value'] !== 'undefined') {
                            data = {
                                [errors[i]['field']]: errors[i]['value'] || '---',
                            }
                        }
                        error.data = data;
                        errorsArray.push(error);
                    }
                }
            } else if (typeof errors.code !== 'undefined' && errors.code !== 'UNDEFINED') {
                error.code = errors.code;
                if (typeof errors['field'] !== 'undefined' && errors['field'] && typeof errors['value'] !== 'undefined') {
                    data = {
                        [errors['field']]: errors['value'] || '---'
                    }
                }
                error.data = data;
                errorsArray.push(error);
            }
        } else if (errors !== 'UNDEFINED' || errors !== '') {
            errorsArray = [{
                code: (errors === 'Unexpected error') ? 'Unexpectederror' : errors,
                data,
            }];
        }

        // setFormattedErrors(errorsArray.length == 0 ? predefined : errorsArray);

        return errorsArray.length == 0 ? predefined : errorsArray;
    };


    return (<>
        { props.errors && generateErrors(props.errors).map((value, index) => {


            if (index < props.errors.length - 1) {
                return <p key={index}>{ t(value.code, value.data) }</p>
            } else {
                return <span key={index}>{ t(value.code, value.data) }</span>
            }
        }) }
    </>)
};

export default ErrorsRequest;
